/* eslint-disable no-template-curly-in-string */
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import { Form } from 'formik';
import { deviceSizes } from '../../../../config/devices'

export const SignInContainer = styled(Grid)`
  && {
    margin-top: 2rem;
    /* padding-bottom: 1rem; */
    text-align: center;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;

export const ButtonContainer = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-top: 2rem;
  }
`;

export const useClasses = makeStyles(() => ({
  recaptchaContainer: {
    [`@media (max-width: ${deviceSizes.sm})`]: {
      // marginRight: 'auto',
      // marginLeft: 'auto',
      // width: 'fit-content',
      marginTop: '15px'
    },
  },
}));